import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { mapActions, mapGetters } from 'vuex';
import * as types from '@reserve/store/types'
import { getResourceColor } from '@reserve/store/consts';
import reserveHelper from '@reserve/reserve-helper';
import * as popupHelper from '@appbase/util/popup-helper';
import modalHelper from '@appbase/util/modal-helper';
import ResourceInformationModal from '../ResourceInformationModal.vue';

@Component({
    name: 'resource-item-db',
    computed: mapGetters({
        isLoading: types.CALENDAR_LOADING,
        selectedResourceKeys: types.SELECTED_RESOURCE_KEYS
    }),

    methods: mapActions({
        selectResource: types.TOGGLE_RESOURCE_SELECT,
        selectGroup: types.TOGGLE_RESOURCEGROUP_SELECT
    })
})
export default class ResourceItemDb  extends Vue {
    @Prop({ type: Object }) item!: reserve.DbResourceItem;

    selectResource!: (payload: { category: 'EWS' | 'DB' | 'FAVORITE', id: string, select: boolean }) => void;
    selectGroup!: (payload: { category: 'EWS' | 'DB' | 'FAVORITE', id: string, select: boolean }) => void;

    isLoading!: boolean;
    selectedResourceKeys!: string[];

    isCollapsed: boolean = false;
    selected: boolean = false;
    colorCodeClass: any = {};
    childItems: reserve.DbResourceItem[] = [];

    @Watch('selectedResourceKeys')
    OnSelectChanged(newVal: string[]) {        
        this.selected = newVal.indexOf(`${this.item.uniqueId}-${this.item.parentId}`) >= 0;
        this.colorCodeClass[this.item.colorCode] = this.selected;
    }

    created() {
        this.selected = this.item.selected;
        this.childItems = this.item.childItems;
        this.colorCodeClass[this.item.colorCode] = this.selected;

        var childIds = this.item.childItems.map(c => {return `${c.uniqueId}-${c.parentId}`});
        this.isCollapsed = childIds.length > 0 && childIds.some(c => this.selectedResourceKeys.indexOf(c) >= 0);

        this.OnSelectChanged(this.selectedResourceKeys);
    }

    onToggleFoldClick() {
        this.isCollapsed = !this.isCollapsed;
    }

    selectChanged() {       
        if(reserveHelper.isHeaderType(this.item.resourceType)) {            
            this.selectGroup({ category: 'DB',  id: `${this.item.uniqueId}`, select: this.selected })
        } else {
            this.selectResource({ category: 'DB',  id: `${this.item.uniqueId}-${this.item.parentId}`, select: this.selected });
        }        
    }

    getColorCode(uniqueId: string) {
        if(this.selected) {          
            return getResourceColor(uniqueId);
        } else {    
            return null;
        }
    }

    onInformationClick() {
        if(this.isTeams) {
            modalHelper.show({
                component: ResourceInformationModal,
                value: this.item.uniqueId        
            })
        } else {
            popupHelper.openPopup(`resourceInfo_${this.item.uniqueId}`, "/reservePopup/info",
            {
                uniqueId: this.item.uniqueId
            },
            {
                width: 620,
                height: 700,               
            })         
        }     
    }
}